import { VLayout } from '@sleepstation/components-layouts'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const PageBody = styled(VLayout).attrs({ spacing: 1.5 })`
  background: transparent;
`

export default PageBody
